import { render } from "./routing.vue?vue&type=template&id=81186a66"
import script from "./routing.vue?vue&type=script&lang=js"
export * from "./routing.vue?vue&type=script&lang=js"

import "./routing.vue?vue&type=style&index=0&id=81186a66&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__